import { debounce } from "@sazka/utils/debounce";

export function useHeader() {
    let prevScroll = window.scrollY;
    const body = document.body;
    const btn = document.querySelector('[data-js="hsr-toggle"]');
    const nav = document.querySelector('[data-js="hsr-nav"]');
    const header = document.querySelector('[data-js="hsr-header"]');

    function handleToggle() {
        body.classList.toggle("open-header");
        nav.classList.toggle("hsr-header__nav--active");
        btn.classList.toggle("hsr-header__toggle--active");
    }

    function handleScroll() {
        const currentScroll = window.scrollY;

        if (prevScroll >= currentScroll) {
            header.classList.add("hsr-header--active");
        } else {
            header.classList.remove("hsr-header--active");
            header.classList.remove("hsr-header--parallax");
        }

        prevScroll = Math.max(currentScroll, 0);
    }

    btn.addEventListener("click", handleToggle);
    window.addEventListener("scroll", debounce(handleScroll, 10), { passive: true });
}
